import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {setExpandedFilters, setSelectedFilters} from "../../FeatureCreator/FeaturesFilters/FeaturesFiltersActions";
import {toggleArrayValue, toggleFilterArrayValue} from "../../FeatureCreator/FeaturesFilters/filtersFunctions";
import PricingCheckbox from "../PricingComponents/PricingCheckbox";
import MaterialsIcons from "../../Icons/MaterialsIcons";


const PricingFiltersFilterItem = (props) => {

  const {filterGroup, expandedFilters, setExpandedFilters, selectedFilters, setSelectedFilters} = props;

  const expandFilterClick = () => {
    setExpandedFilters(toggleArrayValue(expandedFilters, filterGroup.id))
  }

  const selectFiltersClick = (fValue) => {
    setSelectedFilters(
      toggleFilterArrayValue(
        [...selectedFilters],
        {filterId: fValue.id, filterGroupId: filterGroup.id}
      )
    )
  }

  return (
    <li className={"pr-filter mb-025" + (expandedFilters.includes(filterGroup.id) ? " pr-filter--expanded" : "")}
        key={filterGroup.id}>
      <div className="">
        <button onClick={expandFilterClick}
                className={"link link--gray4 width-100 link--green-hover flex flex--center flex--between bg-none " +
                  "border-none box-shadow-none"}>
          <span className="">{filterGroup.name}</span>
          <span className="material-icon transition">
            {MaterialsIcons.ChevronRight}
          </span>
        </button>
      </div>
      <div className="pr-filter__values pl-125">
        <ul className="fix-ul">
          {filterGroup.values.map((fValue) => {
            const checked = selectedFilters.some(selFilter => selFilter.filterId === fValue.id);
            return (
              <li key={fValue.id} className="mb-1">
                <PricingCheckbox id={fValue.id}
                                 text={fValue.displayText || fValue.value}
                                 className="color-textgray bold font--12"
                                 checked={checked}
                                 onChange={() => selectFiltersClick(fValue)}/>
              </li>
            )
          })}
        </ul>
      </div>
    </li>
  )
};

PricingFiltersFilterItem.propTypes = {
  filterGroup: PropTypes.object.isRequired,
}

const mapStateToProps = (store) => {
  const {selectedFilters, expandedFilters} = store.featuresFiltersState;
  return {
    selectedFilters,
    expandedFilters,
  };
};

const mapDispatchToProps = {
  setExpandedFilters,
  setSelectedFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingFiltersFilterItem);
